import styled from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: ${({ theme }) => theme?.colors?.white};
  width: 100%;
  height: 100vh;
  padding-top: 15px;

  @media (min-width: calc(${BREAKPOINT_SM})) {
    border-radius: 4px;
    height: auto;
    width: 644px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 15px;
  overflow-y: auto;

  @media (min-width: calc(${BREAKPOINT_SM})) {
    padding: 20px;
  }
`

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 15px;
  background-color: ${({ theme }) => theme?.colors?.gray1};

  @media (min-width: calc(${BREAKPOINT_SM})) {
    padding: 20px;
    border-radius: 0 0 4px 4px;
  }
`

export const Image = styled.div`
  height: 350px;
`
export const Title = styled.h2`
  margin: 0;
  font-weight: 800;
  font-size: 20px;
`
export const Description = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  white-space: pre-line;
`

export const Variant = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
`
export const VariantHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`
export const VariantHeaderDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`
export const VariantTitleGroup = styled.div`
  display: flex;
  align-items: baseline;
  gap: 5px;
`
export const VariantTitle = styled.h3`
  margin: 0;
  font-weight: 700;
  font-size: 14px;
`
export const VariantAge = styled.span`
  font-weight: 400;
  font-size: 11px;
  color: ${({ theme }) => theme?.colors?.gray5};
`
export const VariantPrice = styled.span`
  font-weight: 800;
  font-size: 13px;
`
export const VariantQuantity = styled.div``

export const Price = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`
export const TotalLabel = styled.span`
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
`
export const TotalValue = styled.span`
  font-weight: 700;
  font-size: 20px;
  color: ${({ theme }) => theme?.colors?.priceColor};
`

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const VariantContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;

  @media (min-width: calc(${BREAKPOINT_SM})) {
    gap: 15px;
  }
`

export const VariantItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: calc(${BREAKPOINT_SM})) {
    flex-direction: row;
    justify-content: space-between;
  }
`
export const VariantItemOptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;
`
export const VariantSchedule = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`
export const VariantExtras = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;
  width: 100%;
`
export const VariantExtra = styled.div`
  width: 100%;
`
